import React from "react";
import { Row, Col } from "antd";
import POSLogo from "../../assets/images/NewLogoCW.svg";
import LockIcon from "../../assets/images/lock-icon.svg";
import userIcon from "../../assets/images/userId.svg";
import Online from "../../assets/images/green.svg";
import Offline from "../../assets/images/red.svg";
import BackIcon from "../../assets/images/backIcon.svg";

const Header = ({ currentDateTime, tillValue, onBack, onPosClick }) => {
  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "8px 12px",
        marginBottom: "12px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <Row align="middle" justify="space-between">
        <Col>
          <Row align="middle" gutter={8}>
            <Col>
              <img src={BackIcon} style={{ height: "24px", cursor: "pointer" }} onClick={onBack} alt="Back" />
            </Col>
            <Col>
              <img src={POSLogo} style={{ height: "32px", cursor: "pointer" }} onClick={onPosClick} alt="POS Logo" />
            </Col>
          </Row>
        </Col>
        <Col>
          <Row align="middle" gutter={8}>
            <Col>
              <span style={{ fontSize: "12px", color: "#6b7280" }}>{formattedDateTime}</span>
            </Col>
            <Col>
              <img src={LockIcon} style={{ height: "20px", cursor: "pointer" }} alt="Lock" />
            </Col>
            <Col>
              <div
                style={{
                  border: "1px solid #4b5563",
                  borderRadius: "50%",
                  padding: "4px",
                }}
              >
                <img src={userIcon} style={{ height: "20px" }} alt="User" />
              </div>
            </Col>
            <Col>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "12px", fontWeight: 500 }}>{JSON.parse(localStorage.getItem("userData")).user}</span>
                <span style={{ fontSize: "10px", color: "#6b7280" }}>Till ID: {tillValue?.name}</span>
              </div>
            </Col>
            <Col>
              <img src={navigator.onLine ? Online : Offline} style={{ height: "20px" }} alt={navigator.onLine ? "Online" : "Offline"} />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Header;